




































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class'

import DigitalCurrency1DigitalCurrencySymbol from '../basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'
import DigitalCurrency6AccountUserProfilePicture from '../basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'

import UserInterface6HtmlReader from './user-interface-6-html-reader.vue'

import {
  NOTIFICATION_TYPE_ACCOUNT,
  NOTIFICATION_TYPE_TRANSACTION,
  NOTIFICATION_TYPE_GENERAL
} from '../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-1-data-structures/data-structures-1-root-state'

import {
  REMOVE_NOTIFICATION,
  TOGGLE_SHOW_NOTIFICATION_LIST
} from '../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-2-algorithms/algorithms-type-1-mutations/mutations-1-general'

import { getTimeAgoSinceNow } from '../basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-6-get-time-ago-since-now'

// import { getIndexListForSubstring } from './service-for-algorithms/algorithms-4-get-index-list-for-substring'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol,
    DigitalCurrency6AccountUserProfilePicture,
    UserInterface6HtmlReader
  }
})
class UserInterface4NotificationList extends Vue {

  @State('showNotificationList') showNotificationList?: boolean
  @State('notificationList') notificationList?: any[]

  @Mutation(REMOVE_NOTIFICATION) REMOVE_NOTIFICATION?: any
  @Mutation(TOGGLE_SHOW_NOTIFICATION_LIST) TOGGLE_SHOW_NOTIFICATION_LIST?: any

  digitalCurrencySymbolImageIconUrl = projectVariables.digitalCurrencySymbolImageIconUrl

  NOTIFICATION_TYPE_ACCOUNT: string = NOTIFICATION_TYPE_ACCOUNT
  NOTIFICATION_TYPE_TRANSACTION: string = NOTIFICATION_TYPE_TRANSACTION
  NOTIFICATION_TYPE_GENERAL: string = NOTIFICATION_TYPE_GENERAL

  millisecondDelayToHideNotification: number = -1 // 10 * 1000 // 10 seconds

  maximumNumberOfNotificationsToShow: number = 2

  get showNotification () {
    return this.showNotificationList
  }

  set showNotification (value: any) {
    this.TOGGLE_SHOW_NOTIFICATION_LIST(value)
  }

  get notificationItemListWithFilter () {
    return (this.notificationList || []).filter((_notificationItem: any, index: number) => {
      return ((index + 1) <= this.maximumNumberOfNotificationsToShow) ? true : false
    })
  }

  removeNotificationItem (itemIndex: number) {
    this.REMOVE_NOTIFICATION(itemIndex)
  }

  getTimeAgoSinceNow (date: Date) {
    return getTimeAgoSinceNow(date)
  }
}

export default UserInterface4NotificationList

